import { inject, Injectable, signal } from '@angular/core';
import { DataLayerService } from '../data-layer/data-layer.service';
import {
	CourseSearchLocationGA,
	CourseSearchLocationGAEnum,
	DegreeLevelLabel,
	CourseSearchErrors,
} from '@uc/web/shared/data-models';

@Injectable({ providedIn: 'root' })
export class CourseGAService {
	noSearchTermError = signal(false);
	private dataLayerSrv = inject(DataLayerService);

	private _isAutosuggest = false;
	private _searchLocation: CourseSearchLocationGA = CourseSearchLocationGAEnum.Default;

	getAutosuggest() {
		const temp = this._isAutosuggest;
		this._isAutosuggest = false;
		return temp;
	}
	setAutosuggest(value: boolean) {
		this._isAutosuggest = value;
	}

	getSearchLocation() {
		const temp = this._searchLocation;
		this._searchLocation = CourseSearchLocationGAEnum.Default;
		return temp;
	}
	getSearchLocationWithoutReset() {
		return this._searchLocation;
	}
	setSearchLocation(value: CourseSearchLocationGA) {
		this._searchLocation = value;
	}

	/**
	 * When user clicks view more courses button
	 */

	viewMore(uniId: number, uniName: string, searchTerm: string) {
		this.dataLayerSrv.push({
			eventName: 'see_more_courses_button_click',
			university: uniId,
			universityName: uniName,
			searchQuery: searchTerm,
			event: 'viewMore',
		});
	}

	// when user lands on the course search page
	courseSearch(
		searchTerm: string,
		searchLocation: CourseSearchLocationGA,
		heCosSubject: boolean,
		degreeLevel: DegreeLevelLabel,
		errorEncountered: CourseSearchErrors | boolean,
		autoSuggest: boolean,
		region?: string,
	) {
		const formattedSearchTerm = searchTerm.split('-').join(' ');

		const trackingData = {
			eventName: 'course_search',
			searchTerm: formattedSearchTerm,
			heCosSubject: heCosSubject ? formattedSearchTerm : false,
			searchLocation,
			degreeLevel,
			errorEncountered,
			autoSuggest,
			regionFilter: region ?? false,
			event: 'courseSearch',
		};

		this.dataLayerSrv.push(trackingData);
	}
}
